import React, { memo, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Col, Modal, Row } from 'react-bootstrap'
import SeedMap from './SeedMap'
import { Heading6 } from '../widgets'
import { getGeoRegionDetail } from '../../actions/geo';
import { isAutomaticLoad } from '../../helpers/common'
// import LoadTimeLine from '../LoadHistory/LoadTimeLine'
import SeedTimeLine from '../seedHistory/SeedTimeLine'
import { getSeedTimeLine } from '../../actions/plan'

const SeedLocationPopup = ({ show, onHide, farmId, load }) => {
	const regionsDetail = useSelector(state => state.geo.regionsDetails);
	const dispatch = useDispatch();

	const [loadInfo, setLoadInfo] = useState(null);

	useEffect(() => {
		if (show) dispatch(getGeoRegionDetail({ farm_uuid: farmId }, true));
	}, [farmId]);

	useEffect(() => {
		if (!show) setLoadInfo(null);
		else {
			const { load_activity_uuid, events } = load || {};

			let loadLocation = events && events.length !== 0 ? events.filter(e => e.event_status === (isAutomaticLoad() ? 1 : 4)) : [];
			loadLocation = loadLocation.length !== 0 ? loadLocation.map((e) => {
				return {
					lat: e.latitude,
					lng: e.longitude
				};
			}) : [];

			setLoadInfo({
				...load, location: loadLocation
			});

			dispatch(getSeedTimeLine({ farm_uuid: farmId, load_activity_uuid: load_activity_uuid }));
		}
	}, [show, load]);

	return (
		<Modal
			show={show}
			onHide={onHide}
			className="modal-loadpopup"
			centered
			size="xl"
		>
			<Modal.Header closeButton>
				<Modal.Title><Heading6>Load Timeline + Location</Heading6>
				</Modal.Title>
			</Modal.Header>

			<Modal.Body className="py-0" >
				<Row>
					<Col className='col-5'>
						<SeedTimeLine
							loadActivityId={load.load_activity_uuid}
							loadInfo={loadInfo}
						/>
					</Col>
					<Col className='col-7'>
						<SeedMap
							regionsDetail={regionsDetail}
							location={loadInfo && loadInfo.location.length !== 0 ? loadInfo.location : []}
							loadInfo={loadInfo}
						/>
					</Col>
				</Row>
			</Modal.Body>
		</Modal >
	)
}

export default memo(SeedLocationPopup)